module.exports = __webpack_public_path__ + "static/multiformat-e992414ef65112421993c239bf5244c7.svg";